import { createIcon } from '@chakra-ui/react';

export const InfoFilledIcon = createIcon({
  displayName: 'InfoFilledIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '5',
    width: '5',
  },
  path: (
    <>
      <circle fill="#1D85E8" cx="12" cy="12" r="12" />
      <path
        d="M12 16V12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H12.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});
